import {questionConstants} from "../../constants";

const initialState ={
    data: null,
    registResult: null,
    status: [],
    select: [],
    prev:{},
    next:{},
    recordItems:[],
    isLoading: false,
    isFailure: false,
    page: 0,
    showTerms: false,
    showPwdPopup: false,
    pwdType: null,
    selectSeq: null,
    pwdConfirm : null,
    isDelete: false,
    token: null,
}

export default function question(state = initialState, action){
    switch (action.type){
        /******
         문의하기
         *****/
        case questionConstants.REGISTER_REQUEST:
            return{
                ...state,
                isLoading: !state.isLoading
            }
        case questionConstants.REGISTER_SUCCESS:
            return{
                ...state,
                registResult: action.response?.data
            }
        case questionConstants.REGISTER_FAILURE:
            return{
                ...state,
                isLoading: false,
                isFailure: true,
            }
        case questionConstants.REGISTER_RESET:
            return {
                ...state,
                registResult: null,
            }

        /******
         리스트
         *****/
        case questionConstants.LOAD_REQUEST:
            return{
                ...state,
                isLoading: !state.isLoading,
                registResult: null,
            }
        case questionConstants.LOAD_SUCCESS:
            return{
                ...state,
                data: action.response.data.payload
            }
        case questionConstants.LOAD_FAILURE:
            return{
                isLoading: false,
                isFailure: true,
            }

        /*******
         상세조회
         **********/

        case questionConstants.DETAILS_REQUEST:
            return {
                ...state,
                isLoading:  !state.isLoading,
                isDelete: false,
                pwdConfirm: false,
                showTerms: false,
                showPwdPopup: false,
            }
        case questionConstants.DETAILS_SUCCESS:
            return {
                ...state,
                select: action.response.data.payload?.content,
                prev: action.response.data.payload?.prev,
                next: action.response.data.payload?.next,
            }
        case questionConstants.DETAILS_FAILURE:
            return{
                isLoading: false,
                isFailure: true,
            }

        /******
         비밀번호 체크
         *****/
        case questionConstants.PWD_REQUEST:
            return{
                ...state,
                isLoading: !state.isLoading,
                pwdConfirm: null,
            }
        case questionConstants.PWD_SUCCESS:
            return{
                ...state,
                pwdConfirm: action.response.data.payload.isMatched,
                token: action.response.data.payload.token
            }
        case questionConstants.PWD_FAILURE:
            return{
                isLoading: false,
                isFailure: true,
                pwdConfirm: null,
            }

        /******
         비밀번호 체크
         *****/
        case questionConstants.DELETE_REQUEST:
            return{
                ...state,
                isDelete: false,
            }
        case questionConstants.DELETE_SUCCESS:
            return{
                ...state,
                isDelete: true,
            }
        case questionConstants.DELETE_FAILURE:
            return {}

        /*******
         선택
          *******/

        case questionConstants.SELECT_REQUEST:

            window.open('/canvasNew/composeViewer_new.htm?menuId=104&cntrctNo='+action.params,'_blank')

            return{
                ...state,
                isLoading: !state.isLoading,
            }
        /**
         * UI관련 옵션
         */
        case questionConstants.SHOW_TERMS:
            return{
                ...state,
                showTerms: action.isShow,
            }
        case questionConstants.SHOW_PWD_POPUP:
            return{
                ...state,
                showPwdPopup: action.isShow,
                pwdType: action.pwdType,
                pwdConfirm: action.pwdConfirm,
                selectSeq: action.selectSeq,
            }
        default:
            return state
    }
}